.breadcrumb {
    display: flex;
    align-items: end;
    color: var(--colorTextSecondary);
    font-family: var(--fontFamilySansMedium), sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.25;
}

.breadcrumbs {
    display: flex;
    align-items: end;
    gap: var(--spacing-xxs);
    list-style: none;
    margin: 0;
    padding: 0;
}

.link {
    color: inherit;
    font: inherit;
    text-decoration: none;
    cursor: pointer;
    outline: none;
}

.link[data-hovered],
.link[data-pressed] {
    text-decoration: underline;
}

.link[data-focus-visible] {
    outline: 1px solid var(--colorBorderAccent);
    outline-offset: 2px;
}

/* The current page and crumbs with no destination are not interactive. */
.link[data-disabled] {
    cursor: default;
}
